import { AfterViewInit, Component, Injector, Input, OnInit } from '@angular/core';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { UserService } from '../../services/user-service.service';
import { watch } from 'fs';

@Component({
  selector: 'laas-user-preview',
  templateUrl: './user-preview.component.html',
  styleUrls: ['./user-preview.component.scss']
})
export class UserPreviewComponent extends BaseComponent implements OnInit, AfterViewInit {
  @Input() uuid: string = "" ;
  userId: string;

  //save attribute
  userType: string;
  email: string;
  userName: string;
  employCode: string;
  account: string;
  roleScopes: any[];

  //dropdown list
  roleOptions: any[];
  forwarderOptions: any[];
  facilityOptions: any[];
  tenantOptions: any[];
  customerOptions: any[];

  isShowUserProfile:boolean = false;

  constructor(
    private injector: Injector,
    private userService: UserService
  ) {
    super(injector);
    this.userId = "";
    this.userType = "";
    this.email = "";
    this.userName = "";
    this.employCode = "";
    this.account = "";
    this.roleScopes = [];

    //dropdown list
    this.roleOptions = [];
    this.forwarderOptions = [];
    this.facilityOptions = [];
    this.tenantOptions = [];
    this.customerOptions = [];
  }
  ngAfterViewInit(): void {

  }

  hasRole(usereType: string):boolean{
    return this.userType == usereType;
  }

  userTypeChange(event: any, isClearScope: boolean): void{
    if(!isNullOrEmpty(this.userType)){
      this.userService.getRoleOptions(this.userType).subscribe({
        next: result => {
          this.roleOptions = result.map((x: any) => {
            return {
              label: x.roleName,
              value: x.roleCode
            };
          });

          this.roleOptions.unshift({
            label: "",
            value: ""
          });

          if(isClearScope){
            this.roleScopes = [];
          }
        },
        complete: () => {

        }
      });
    }
  }

  async ngOnInit(): Promise<void> {

    setTimeout(() => {
      this.loader.show();
    });

    //option prepare
    this.userService.getFacilityOptions().subscribe({
      next: result =>{
        this.facilityOptions = result.map((x: any) => {
          return {
            label: `${x.optionCode} ${x.optionDesc}`,
            value: x.optionCode
          }
        });
        this.facilityOptions.unshift({
          label: "",
          value: ""
        });
      },
      complete: () => {

      }
    });

    this.userService.getForwarderOptions().subscribe({
      next: result => {
        this.forwarderOptions = result.map((x: any) => {
          return {
            label: `${x.value} ${x.text}`,
            value: x.value
          }
        });
        this.forwarderOptions.unshift({
          label: "",
          value: ""
        });
      },
      complete: () => {

      }
    });

    this.userService.getTenantOptions().subscribe({
      next: result => {
        this.tenantOptions = result.map((x: any) => {
          return {
            label: `${x.tenantCode} ${x.tenantName}`,
            value: x.tenantCode
          }
        });
        this.tenantOptions.unshift({
          label: "",
          value: ""
        });
      },
      complete: () => {

      }
    });

    try{
      var customerServiceOptions = await this.userService.getCustomerOptions();

      this.customerOptions = customerServiceOptions.map((x: any) => {
        return {
          label: `${x.customerCode} ${x.customerName}`,
          value: x.customerCode
        }
      });

      this.customerOptions.unshift({
        label: "請選擇",
        value: ""
      });

      //沒傳UUID近來代表是從上方Menu點的
      if (this.routeStateService.getCurrent()?.data != null) {
        const data = this.routeStateService.getCurrent().data;
        this.userId = data.userId;
        this.isShowUserProfile = true;
      }else if (!isNullOrEmpty(this.uuid)){
        this.userId = this.uuid;
        this.isShowUserProfile = false;
      }

      if(!isNullOrEmpty(this.userId)){
        this.userService.getUserScope(this.userId).subscribe({
          next: result => {
            this.account = result.account;
            this.email = result.email;
            this.userName = result.userName;
            this.employCode = result.employCode;
            this.userType = result.userType;
            this.roleScopes = result.roleScopes;
            this.userTypeChange(null, false);
          }
        });
      }
    }catch(err) {
      console.log('get Customer Options Error');
    }

    this.loader.hide();
    // this.userService.getCustomerOptions().subscribe({
    //   next: result => {
    //     this.customerOptions = result.map((x: any) => {
    //       return {
    //         label: `${x.customerCode} ${x.customerName}`,
    //         value: x.customerCode
    //       }
    //     });
    //     this.customerOptions.unshift({
    //       label: "請選擇",
    //       value: ""
    //     });
    //   },
    //   complete: () => {

    //   }
    // });
  }

}
